module.exports = __webpack_public_path__ + "img/icon-termossifao.59c35a94.svg";